// src/hooks/useRedirectToHome.js
import { useNavigate } from "react-router-dom";
import ROUTES from "../constants/RouteData";

// This returns a function you can call to redirect to home
const useRedirectToHome = () => {
  const navigate = useNavigate();
  return () => navigate(ROUTES.home);
};

export default useRedirectToHome;
